import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import JobComponent from '../components/JobComponent';
import IAppState from '../../../IAppState';
import { IJobComponentPropsData, IJobComponentPropsFunctions } from '../props/IJobComponentProps';
import ActJob from "../state/act-job";
import ActMain from "../../../act-main";
import IJobInfo from '../interfaces/IJobInfo';
import { ll_fetch } from '../../../tools';
import actMain from '../../../act-main';

async function loadJobInfo(dispatch: any, jobId: string, clear: boolean, succCallback: any) {

    // As results are stored in the main state, clear main state if job ID has changed.
    dispatch(ActMain.resetMainState());

    dispatch(ActJob.infoRequest(clear));
    const response = await ll_fetch(`/api/jobInfo?jobId=${jobId}`);
    
    if (response.ok) {
        try {
            const data = await response.json();
            dispatch(ActJob.infoSuccess(data));
            if (succCallback !== undefined) {
                succCallback(data);
            }
        } catch (err) {
            dispatch(ActJob.infoFailure());
            console.error(err);
        }
    } else if (response.status === 404) {
        dispatch(ActJob.infoNonExist());
    } else {
        dispatch(ActJob.infoFailure());
    }

    dispatch(actMain.setJobId(jobId));
}


const mapStateToProps = (state: IAppState): IJobComponentPropsData => ({
    jobState: state.jobState,
    chainMapping: state.mainState.chainMapping,
    pdbId: state.mainState.pdbIdField,
})

const mapDispatchToProps = (dispatch): IJobComponentPropsFunctions => ({
    loadJobInfo: (jobId: string, clear: boolean, succCallback: any) => loadJobInfo(dispatch, jobId, clear, succCallback),
})


const JobContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(JobComponent))

export default JobContainer;
